export default "__VITE_ASSET__28213269__"